import request from '@/utils/request';

// 获取资讯内容管理列表
export function getProsepoemsList(options) {
  return request({
    url: `/prosepoems/page`,
    method: 'get',
    params: options
  });
}
// 获取资讯内容管理列表
export function getProsepoemsBatch(options) {
  return request({
    url: `/prosepoems/batch`,
    method: 'post',
    data: options
  });
}
// 获取资讯内容管理列表
export function getProsepoemsAdd(options) {
  return request({
    url: `/prosepoems/`,
    method: 'post',
    data: options
  });
}
// 获取资讯内容管理列表
export function getProsepoemsEdit(options) {
  return request({
    url: `/prosepoems/${options.id}`,
    method: 'post',
    data: options
  });
}

// 获取资讯内容管理列表
export function getAdvertisingsList(options) {
  return request({
    url: `/deskadvertisings/page`,
    method: 'get',
    params: options
  });
}
// 获取资讯内容管理列表
export function getAdvertisingsBatch(options) {
  return request({
    url: `/deskadvertisings/batch`,
    method: 'post',
    data: options
  });
}
// 获取资讯内容管理列表
export function getAdvertisingsAdd(options) {
  return request({
    url: `/deskadvertisings/`,
    method: 'post',
    data: options
  });
}// 获取资讯内容管理列表
export function getAdvertisingsEdit(options, id) {
  return request({
    url: `/deskadvertisings/${id}`,
    method: 'post',
    data: options
  });
}
// 获取资讯内容管理列表
export function getAdvertisingsUpload(options) {
  return request({
    url: `/deskadvertisings/upload`,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    method: 'post',
    data: options
  });
}

// 获取资讯内容管理列表
export function getHomemanages(options) {
  return request({
    url: `/homemanages/page`,
    method: 'get',
    params: options
  });
}
// 获取资讯内容管理列表
export function getHomemanagesBatch(options) {
  return request({
    url: `/homemanages/`,
    method: 'post',
    data: options
  });
}
// 获取资讯内容管理列表
export function deskadvertisingsPublish(options) {
  return request({
    url: `/deskadvertisings/publish`,
    method: 'post',
    data: options
  });
}
